import { defaultCurrency, defaultLocale } from '~/constants/localizationDefaults';

const currencyFormatter = ({
  locale = defaultLocale,
  currency = defaultCurrency,
}: {
  locale?: string;
  currency?: string;
}) =>
  new Intl.NumberFormat(locale, {
    style: 'currency',
    currency: currency,
    trailingZeroDisplay: 'stripIfInteger',
  });

export default currencyFormatter;
